import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=5d52eb04&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=5d52eb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52eb04",
  null
  
)

export default component.exports